import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'; 
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/index.css'
import VueCookies from 'vue-cookies'

// moment
import moment from 'moment'
Vue.prototype.$moment = moment;

Vue.use(Antd)
Vue.use(VXETable)
Vue.use(VueCookies)
Vue.prototype.$form = Antd.Form

axios.defaults.baseURL = process.env.VUE_APP_INTERFACE;
//增加认证
axios.interceptors.request.use(config => {
  //config是axios配置对象
  //每次发送请求前都会进入此拦截器处理函数，可以在此处统一携带上token，每次请求都会自
  console.log(VueCookies.get('username'))
  config.headers.common['authorization'] = VueCookies.get('username');
  return config
},err => {
  //请求出错的处理函数
  return Promise.reject(err)
})

Vue.config.productionTip = false;
Vue.prototype.$axios = axios;
Vue.prototype.$cookies = VueCookies;
Vue.prototype.$config = {}; 
Object.defineProperties(Vue.prototype.$config, Object.assign({}, ...Object.entries(process.env).map(([key, value]) => ({ [key.replace('VUE_APP_', '')]: { get() { return process.env[key] } } }))));

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
